import BookmarkIcon from '@mui/icons-material/Bookmark';
import EventIcon from '@mui/icons-material/Event';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import GradeIcon from '@mui/icons-material/Grade';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import ChatIcon from '@mui/icons-material/Chat';
import CalendarViewMonth from '@mui/icons-material/CalendarViewMonth';

import strings from '../../resources/strings';
import { SidebarInterface } from './types';
import routes from '../../resources/routes';

export const sidebarInfoAdmin: SidebarInterface[] = [
    {
        id: 1,
        title: strings.sidebar.sidebarInfo[0],
        url: routes.KNOWLEDGE,
        img: MenuBookIcon,
    },
    {
        id: 2,
        title: strings.sidebar.sidebarInfo[1],
        url: routes.NEWS_AND_EVENTS,
        img: EventIcon,
    },
    {
        id: 3,
        title: strings.sidebar.sidebarInfo[2],
        url: routes.MISSIONS,
        img: LibraryBooksIcon,
    },
    {
        id: 4,
        title: strings.sidebar.sidebarInfo[3],
        url: routes.ADDITIONAL_MISSIONS,
        img: BookmarkIcon,
    },
    {
        id: 5,
        title: strings.sidebar.sidebarInfo[4],
        url: routes.APP_USERS,
        img: AccountBoxIcon,
    },
    {
        id: 6,
        title: strings.sidebar.sidebarInfo[5],
        url: routes.REWARDS,
        img: GradeIcon,
    },
    {
        id: 7,
        title: strings.sidebar.sidebarInfo[6],
        url: routes.DOCUMENTS,
        img: DescriptionIcon,
    },
];

export const sidebarInfoCoach: SidebarInterface[] = [
    {
        id: 8,
        title: strings.sidebar.sidebarInfo[7],
        url: routes.ABOUT,
        img: PersonIcon,
    },
    {
        id: 9,
        title: strings.sidebar.sidebarInfo[8],
        url: routes.CHAT,
        img: ChatIcon,
    },
    {
        id: 10,
        title: strings.sidebar.sidebarInfo[9],
        url: routes.MEETINGS,
        img: CalendarViewMonth,
    },
];
